export default "__VITE_ASSET__C0SfJM8Y__"